import { Typography } from '@mui/material'
import React from 'react'

export const ReportExecutiveCard = ({number, text}) => {
  return (
    <div className="report-executive-card-container bg-white drop-shadow-lg rounded p-3 w-[14vw] flex flex-col hover:bg-slate-50 hover:drop-shadow-xl">
        <Typography sx={{fontWeight: "bold", fontSize: "35px"}}>{number}</Typography>
        <Typography sx={{fontWeight: "bold", fontSize: "large"}}>{text}</Typography>
    </div>
  )
}
